export class GetAmbassadors {
  static readonly type = 'GetAmbassadors';
}

export class GetSponsors {
  static readonly type = 'GetSponsors';
}
